import { render, staticRenderFns } from "./CreateKey.vue?vue&type=template&id=3f8d1642&scoped=true"
import script from "./CreateKey.vue?vue&type=script&lang=js"
export * from "./CreateKey.vue?vue&type=script&lang=js"
import style0 from "./CreateKey.vue?vue&type=style&index=0&id=3f8d1642&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8d1642",
  null
  
)

/* custom blocks */
import block0 from "./CreateKey.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports